import { defineMessages } from 'react-intl';

export default defineMessages({
  days: 'days',
  hours: 'hours',
  minutes: 'minutes',
});
